/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// NOTE: Related issue https://github.com/facebook/react/issues/5867
let idCounter = 0;
/**
 * @deprecated
 *
 * Use the official [`useId` hook](https://beta.reactjs.org/reference/react/useId) instead.
 */
export function uniqueId(prefix = '') {
    idCounter += 1;
    return `${prefix}${idCounter}`;
}
